import React, { useState, useEffect } from 'react';
import Logo from '../components/Logo';
import api from '../api';
import { KAMERA_SUNUCU, DEFAULT_KAMERALAR } from '../data/kameralar';
import useResponsive from '../hooks/useResponsive';

const navBtn = () => ({
  background:'rgba(255,255,255,.08)', border:'1px solid rgba(255,255,255,.15)',
  color:'rgba(255,255,255,.8)', padding:'6px 12px', borderRadius:3, cursor:'pointer',
  fontFamily:"'Barlow Condensed',sans-serif", fontSize:11, fontWeight:700,
  letterSpacing:1, textTransform:'uppercase',
});

export default function Kameralar({ kullanici, onGeriDon }) {
  const { isMobile } = useResponsive();
  const [secilenLok, setSecilenLok] = useState(null);
  const [aktifTab, setAktifTab]     = useState('ic');
  const [acikKamera, setAcikKamera] = useState(null);
  const [kameraAyar, setKameraAyar] = useState(DEFAULT_KAMERALAR);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    const yukle = async () => {
      try {
        const { data } = await api.get('/ayarlar/kameralar');
        if (data?.deger?.lokasyonlar) {
          setKameraAyar({
            lokasyonlar: {
              ...DEFAULT_KAMERALAR.lokasyonlar,
              ...data.deger.lokasyonlar,
            }
          });
        }
      } catch {}
      setYukleniyor(false);
    };
    yukle();
  }, []);

  const kameraAc = (kamera) => {
    if (!kamera.uuid) {
      alert(`${kamera.ad} kamerasının UUID'si henüz tanımlanmamış.`);
      return;
    }
    setAcikKamera(kamera);
  };

  // Lokasyon seçim ekranı
  if (!secilenLok) {
    return (
      <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh' }}>
        <div style={{ background:'var(--ink)', position:'sticky', top:0, zIndex:200 }}>
          <div style={{ maxWidth:1040, margin:'0 auto', padding:isMobile ? '12px 16px' : '0 20px', display:'flex', alignItems:'center', minHeight:isMobile ? 'auto' : 50, gap:12, flexWrap:isMobile ? 'wrap' : 'nowrap' }}>
            <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:22, fontWeight:900, color:'white', letterSpacing:-1 }}>
              <Logo height={24} />
            </div>
            <span style={{ fontSize:11, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.4)', textTransform:'uppercase', flex:isMobile ? '1 1 100%' : '0 1 auto' }}>📹 Kameralar</span>
            <div style={{ marginLeft:isMobile ? 0 : 'auto', width:isMobile ? '100%' : 'auto' }}>
              <button onClick={onGeriDon} style={navBtn()}>‹ Ana Sayfa</button>
            </div>
          </div>
        </div>
        <div style={{ maxWidth:800, margin:'0 auto', padding:isMobile ? '24px 16px 32px' : '48px 20px' }}>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:26, fontWeight:900, marginBottom:8 }}>Lokasyon Seçin</div>
          <div style={{ fontSize:12, color:'var(--muted)', marginBottom:32 }}>Güvenlik kameralarını görüntülemek için lokasyon seçin</div>
          {yukleniyor ? (
            <div style={{ textAlign:'center', padding:40, color:'var(--muted)', fontFamily:"'Barlow Condensed',sans-serif" }}>
              Yükleniyor...
            </div>
          ) : (
            <div style={{ display:'grid', gap:16, gridTemplateColumns:isMobile ? '1fr' : '1fr 1fr' }}>
              {Object.entries(kameraAyar.lokasyonlar || {}).map(([key, lok]) => (
                <div key={key} onClick={() => setSecilenLok(key)} style={{
                  background:'var(--surface)', border:'2px solid var(--border2)', borderRadius:8,
                  padding:'32px 28px', cursor:'pointer', minWidth:0,
                  transition:'all .2s', position:'relative', overflow:'hidden',
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor='var(--accent)'; e.currentTarget.style.transform='translateY(-3px)'; e.currentTarget.style.boxShadow='0 12px 32px rgba(0,0,0,.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor='var(--border2)'; e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}>
                  <div style={{ position:'absolute', top:0, left:0, right:0, height:4, background:'var(--accent)' }} />
                  <div style={{ fontSize:40, marginBottom:14 }}>📹</div>
                  <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:24, fontWeight:900, marginBottom:6 }}>{lok.ad}</div>
                  <div style={{ fontSize:12, color:'var(--muted)' }}>
                    {lok.ic.length} iç · {lok.dis.length} dış kamera
                  </div>
                  <div style={{ marginTop:16, fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:700, color:'var(--accent)', letterSpacing:1, textTransform:'uppercase' }}>
                    Görüntüle →
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  const lok = kameraAyar.lokasyonlar?.[secilenLok];
  if (!lok) {
    return (
      <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh', padding:40, color:'var(--muted)' }}>
        Kamera bilgisi bulunamadı. Lütfen daha sonra tekrar deneyin.
      </div>
    );
  }
  const liste = aktifTab === 'ic' ? lok.ic : lok.dis;

  return (
    <div style={{ fontFamily:"'Barlow',sans-serif", background:'var(--bg)', minHeight:'100vh' }}>

      {/* NAV */}
      <div style={{ background:'var(--ink)', position:'sticky', top:0, zIndex:200 }}>
        <div style={{ maxWidth:1200, margin:'0 auto', padding:isMobile ? '12px 16px' : '0 20px', display:'flex', alignItems:'center', minHeight:isMobile ? 'auto' : 50, gap:12, flexWrap:isMobile ? 'wrap' : 'nowrap' }}>
          <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:22, fontWeight:900, color:'white', letterSpacing:-1 }}>
            <Logo height={24} />
          </div>
          <span style={{ color:'rgba(255,255,255,.2)' }}>›</span>
          <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:700, letterSpacing:2, color:'rgba(255,255,255,.6)', textTransform:'uppercase', flex:isMobile ? '1 1 100%' : 1 }}>
            📹 {lok.ad} Kameraları
          </span>
          <div style={{ marginLeft:isMobile ? 0 : 'auto', display:'flex', gap:8, width:isMobile ? '100%' : 'auto', flexWrap:'wrap' }}>
            <button onClick={() => setSecilenLok(null)} style={navBtn()}>‹ Lokasyon</button>
            <button onClick={onGeriDon} style={navBtn()}>Ana Sayfa</button>
          </div>
        </div>
      </div>

      {/* SEKMELER */}
      <div style={{ background:'var(--ink)', borderBottom:'1px solid rgba(255,255,255,.1)' }}>
        <div style={{ maxWidth:1200, margin:'0 auto', padding:isMobile ? '0 8px' : '0 20px', display:'flex', gap:2, overflowX:'auto', scrollbarWidth:'none' }}>
          {[
            { id:'ic',  ad:`🏭 İç Kameralar`, sayi: lok.ic.length },
            { id:'dis', ad:`🌐 Dış Kameralar`, sayi: lok.dis.length },
          ].map(s => (
            <button key={s.id} onClick={() => setAktifTab(s.id)} style={{
              background: aktifTab === s.id ? 'rgba(255,255,255,.12)' : 'transparent',
              border:'none', borderBottom: aktifTab === s.id ? '2px solid var(--accent)' : '2px solid transparent',
              color: aktifTab === s.id ? 'white' : 'rgba(255,255,255,.55)',
              padding:'12px 16px', cursor:'pointer',
              fontFamily:"'Barlow Condensed',sans-serif", fontSize:12, fontWeight:700,
              letterSpacing:1, textTransform:'uppercase', display:'flex', alignItems:'center', gap:6,
            }}>
              {s.ad}
              <span style={{ background:'rgba(255,255,255,.2)', borderRadius:10, padding:'1px 7px', fontSize:10 }}>{s.sayi}</span>
            </button>
          ))}
        </div>
      </div>

      {/* KAMERA GRİD */}
      <div style={{ maxWidth:1200, margin:'0 auto', padding:isMobile ? '20px 16px 32px' : '24px 20px' }}>
        {yukleniyor ? (
          <div style={{ textAlign:'center', padding:40, color:'var(--muted)', fontFamily:"'Barlow Condensed',sans-serif" }}>
            Yükleniyor...
          </div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:isMobile ? '1fr' : 'repeat(auto-fill, minmax(220px, 1fr))', gap:16 }}>
            {liste.map(k => (
            <div key={k.id} onClick={() => kameraAc(k)} style={{
              background:'var(--surface)', border:'1px solid var(--border2)', borderRadius:6,
              overflow:'hidden', cursor: k.uuid ? 'pointer' : 'not-allowed',
              transition:'all .2s', opacity: k.uuid ? 1 : 0.6,
            }}
            onMouseEnter={e => { if (k.uuid) { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 24px rgba(0,0,0,.12)'; e.currentTarget.style.borderColor='var(--accent)'; }}}
            onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; e.currentTarget.style.borderColor='var(--border2)'; }}>
              {/* Kamera görüntü alanı */}
              <div style={{
                height:140, background:'#0a0a0a', display:'flex', alignItems:'center', justifyContent:'center',
                position:'relative', overflow:'hidden',
              }}>
                {k.uuid ? (
                  <>
                    <div style={{ position:'absolute', top:8, left:8, width:8, height:8, borderRadius:'50%', background:'#2ecc71', boxShadow:'0 0 6px #2ecc71' }} />
                    <div style={{ position:'absolute', top:6, left:20, fontSize:9, color:'rgba(255,255,255,.5)', fontFamily:'monospace' }}>● LIVE</div>
                    <div style={{ fontSize:40, opacity:.3 }}>📹</div>
                    <div style={{ position:'absolute', bottom:8, right:8, fontSize:9, color:'rgba(255,255,255,.4)', fontFamily:'monospace' }}>CAM {k.id.toString().padStart(2,'0')}</div>
                  </>
                ) : (
                  <>
                    <div style={{ position:'absolute', top:8, left:8, width:8, height:8, borderRadius:'50%', background:'#e74c3c' }} />
                    <div style={{ position:'absolute', top:6, left:20, fontSize:9, color:'rgba(255,255,255,.3)', fontFamily:'monospace' }}>● OFFLINE</div>
                    <div style={{ fontSize:40, opacity:.15 }}>📷</div>
                  </>
                )}
              </div>
              {/* Kamera bilgisi */}
              <div style={{ padding:'10px 12px' }}>
                <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:13, fontWeight:800, textTransform:'uppercase', letterSpacing:.5 }}>
                  {k.ad}
                </div>
                <div style={{ fontSize:10, color:'var(--muted)', marginTop:2 }}>
                  {aktifTab === 'ic' ? 'İç Kamera' : 'Dış Kamera'} · #{k.id.toString().padStart(2,'0')}
                </div>
              </div>
            </div>
            ))}
          </div>
        )}
      </div>

      {/* KAMERA MODAL */}
      {acikKamera && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.85)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}
          onClick={() => setAcikKamera(null)}>
            <div style={{ background:'#0a0a0a', borderRadius:8, overflow:'hidden', width:'min(900px, 95vw)', maxHeight:'90vh', display:'flex', flexDirection:'column' }}
            onClick={e => e.stopPropagation()}>
            {/* Modal header */}
            <div style={{ padding:'12px 16px', background:'#111', display:'flex', alignItems:'center', gap:12 }}>
              <div style={{ width:8, height:8, borderRadius:'50%', background:'#2ecc71', boxShadow:'0 0 6px #2ecc71', flexShrink:0 }} />
              <span style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:15, fontWeight:800, color:'white', textTransform:'uppercase', letterSpacing:1, flex:1 }}>
                {acikKamera.ad}
              </span>
              <span style={{ fontSize:10, color:'rgba(255,255,255,.3)', fontFamily:'monospace' }}>
                {lok.ad} · {aktifTab === 'ic' ? 'İÇ' : 'DIŞ'} · CAM {acikKamera.id.toString().padStart(2,'0')}
              </span>
              <button onClick={() => setAcikKamera(null)} style={{ background:'none', border:'none', color:'rgba(255,255,255,.5)', fontSize:20, cursor:'pointer', padding:4 }}>✕</button>
            </div>
            {/* Stream */}
            <div style={{ flex:1, background:'#000', display:'flex', alignItems:'center', justifyContent:'center', minHeight:isMobile ? 260 : 480 }}>
              <iframe
                src={`${KAMERA_SUNUCU}/${acikKamera.uuid}?_=${Date.now()}`}
                style={{ width:'100%', height:isMobile ? 260 : 480, border:'none' }}
                title={acikKamera.ad}
                allowFullScreen
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
